/**
 * @generated SignedSource<<4381e03839d4fa060e11705c6de68d73>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectsList130BadPattern$data = {
  readonly jira: {
    readonly allJiraProjectCategories?: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "JiraProjectCategoryEdge";
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ActionsCell900BadPattern">;
  } | null | undefined;
  readonly " $fragmentType": "ProjectsList130BadPattern";
};
export type ProjectsList130BadPattern$key = {
  readonly " $data"?: ProjectsList130BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectsList130BadPattern">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAnonymous"
    }
  ],
  "kind": "Fragment",
  "name": "ProjectsList130BadPattern",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "isAnonymous",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "args": (v0/*: any*/),
              "concreteType": "JiraProjectCategoryConnection",
              "kind": "LinkedField",
              "name": "allJiraProjectCategories",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraProjectCategoryEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "args": (v0/*: any*/),
          "kind": "FragmentSpread",
          "name": "ActionsCell900BadPattern"
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "29f3500c106aa50f0d628e9ff4233c14";

export default node;
